class AlgoliaAutoCompleteCard extends window.BAO.CustomElement({
  SuperClass: HTMLAnchorElement,
}) {
  constructor () {
    super()
    this.state = {
      trackingInformation: {},
      isActive: false,
    }
  }

  attributeChangedCallback (name, oldValue, newValue) {
    if (oldValue == null) return

    this.els = {
      mobileTrigger: this.querySelector(
        '[data-algolia-autocomplete-card-el="mobile-trigger"]',
      ),
      desktopTrigger: this.querySelector(
        '[data-algolia-autocomplete-card-el="desktop-trigger"]',
      ),
      desktopQuickBuyPlacement: this.querySelector(
        '[data-algolia-autocomplete-card-el="desktop-quick-buy-placement"]',
      ),
    }

    this.setupListeners()
  }

  connectedCallback () {
    this.els = {
      mobileTrigger: this.querySelector(
        '[data-algolia-autocomplete-card-el="mobile-trigger"]',
      ),
      desktopTrigger: this.querySelector(
        '[data-algolia-autocomplete-card-el="desktop-trigger"]',
      ),
      desktopQuickBuyPlacement: this.querySelector(
        '[data-algolia-autocomplete-card-el="desktop-quick-buy-placement"]',
      ),
    }
    this.setupListeners()
  }

  setupListeners () {
    this.addEventListener('click', event => {
      event.stopPropagation()
      this.handleClickEvent(event)
    })

    if (this.els.mobileTrigger !== null) {
      this.els.mobileTrigger.addEventListener(
        'click',
        this.handleMobileQuickBuy.bind(this),
      )
    }

    if (this.els.desktopTrigger !== null) {
      this.els.desktopTrigger.addEventListener(
        'click',
        this.handleDesktopQuickBuy.bind(this),
      )
    }
  }

  handleClickEvent (event) {
    if (event.target.closest('product-form')) return

    event.preventDefault()

    this.buildClickTrackingInformation()

    window.BAO.dispatchEvent(
      window.BAO.EVENTS.ALGOLIA.AFTER_AUTOCOMPLETE_CLICK,
      {
        data: this.state.clickTrackingInformation,
      },
    )

    window.location.href = this.href
  }

  handleFormSubmit (event) {
    const variantId = event.target.querySelector('[name="id"]').value

    this.buildTrackingInformation(variantId)

    window.BAO.dispatchEvent(
      window.BAO.EVENTS.ALGOLIA.AFTER_AUTOCOMPLETE_QUICK_ADD,
      {
        data: this.state.trackingInformation,
      },
    )
  }

  buildClickTrackingInformation () {
    const trackingInformation = {
      productId: this.dataset.productId,
      userToken: '',
      eventType: 'click',
      eventName: 'Item Selected',
      index: this.dataset.index,
      queryID: this.dataset.queryid,
      objectIDs: [this.dataset.variantId],
      objectData: [
        {
          price: this.dataset.price,
          quantity: 1,
        },
      ],
      currency: Shopify.currency.active,
      positions: [Number(this.dataset.position)],
    }

    this.state.clickTrackingInformation = trackingInformation
  }

  buildTrackingInformation (variantId) {
    const trackingInformation = {
      productId: this.dataset.productId,
      userToken: '',
      eventType: 'conversion',
      eventSubtype: 'addToCart',
      eventName: 'Added to cart',
      index: this.dataset.index,
      queryID: this.dataset.queryid,
      objectIDs: [variantId || null],
      objectData: [
        {
          price: this.dataset.price,
          quantity: 1,
        },
      ],
      currency: Shopify.currency.active,
    }

    this.state.trackingInformation = trackingInformation
  }

  handleMobileQuickBuy (event) {
    event.preventDefault()
    event.stopPropagation()

    this.buildTrackingInformation()

    window.BAO.dispatchEvent(window.BAO.EVENTS.MOBILE_QUICK_BUY.OPENED, {
      event,
      productHandle: this.productHandle,
      trackingInformation: this.state.trackingInformation,
    })
  }

  async handleDesktopQuickBuy (event) {
    event.preventDefault()
    event.stopImmediatePropagation()

    const html = await this.sectionRenderer(
      'product-quickbuy',
      `/products/${this.productHandle}?section_id=product-quickbuy`,
    )

    const parsedHTML = new DOMParser().parseFromString(html, 'text/html')

    this.els.desktopQuickBuyPlacement.innerHTML = parsedHTML.querySelector(
      '#shopify-section-product-quickbuy',
    ).innerHTML
    this.querySelector('form').addEventListener(
      'submit',
      this.handleFormSubmit.bind(this),
    )
    this.isActive = true
  }

  async sectionRenderer (sectionId, url) {
    const html = await window.BAO.utils.sectionRenderer.fetchSingle(
      sectionId,
      url,
    )

    return html
  }

  get productHandle () {
    return this.getAttribute('data-product-handle')
  }

  get variants () {
    return this.state.variants
  }

  set variants (value) {
    this.state.variants = value

    this.renderProductForm()
  }

  get isActive () {
    return this.state.isActive
  }

  set isActive (value) {
    this.state.isActive = value

    this.setAttribute('data-quick-buy-is-visible', value)
  }
}

if (!customElements.get('algolia-autocomplete-card')) {
  customElements.define('algolia-autocomplete-card', AlgoliaAutoCompleteCard, {
    extends: 'a',
  })
}
